// 全局搜索数据源
export const searchData = {
    // 产品列表
    products: [
      {
        id: 'cloud-security-resource-pool',
        name: '云安全资源池',
        description: '安全能力池化，为租户/业务按需提供防护能力',
        category: '云安全',
        icon: '/src/assets/products/p1.svg',
        path: '/product/cloud-security-resource-pool',
        keywords: ['云安全', '资源池', '虚拟主机', '安全服务']
      },
      {
        id: 'sslo',
        name: '流量编排器',
        description: '智能流量编排，业务路径重塑',
        category: '云安全',
        icon: '/src/assets/products/p2.svg',
        path: '/product/sslo',
        keywords: ['流量', '调度', '编排', 'SSL', '解密']
      },
      {
        id: 'edge-cloud-platform',
        name: '边缘云',
        description: '提供计算、存储、网络、安全等云原生能力。',
        category: '边缘云',
        icon: '/src/assets/products/p3.svg',
        path: '/product/edge-cloud-platform',
        keywords: ['边缘云', '多租户', '组网', '云网安']
      },
      {
        id: 'edge-cloud/cloud-host',
        name: '智算云',
        description: '通算智算一体，算力切分调度',
        category: '边缘云',
        icon: '/src/assets/products/p3.svg',
        path: '/product/edge-cloud/cloud-host',
        keywords: ['智算云', '通算智算', '算力切分', 'GPU', 'NPU', '边缘云']
      },
      {
        id: 'edge-cloud/containers',
        name: '超融合',
        description: '基于池化技术，提供计算、存储、网络等虚拟化能力',
        category: '边缘云',
        icon: '/src/assets/products/p3.svg',
        path: '/product/edge-cloud/containers',
        keywords: ['超融合', '容器', 'Kubernetes', 'Harbor', '边缘云']
      },
      {
        id: 'compute-network/interconnect',
        name: 'SD-WAN',
        description: '跨域互联、传输加速、基于业务构建动态overlay网络',
        category: '算力网络',
        icon: '/src/assets/products/p9.svg',
        path: '/product/compute-network/interconnect',
        keywords: ['SD-WAN', '跨域互联', 'VR', 'SRv6', '算力网络']
      },
      {
        id: 'compute-network/ecosystem',
        name: 'TB级智能流量筛选',
        description: '按需自动化筛选流量',
        category: '算力网络',
        icon: '/src/assets/products/p9.svg',
        path: '/product/compute-network/ecosystem',
        keywords: ['TB级智能流量筛选', '流筛', '算力网络']
      },
      {
        id: 'sase',
        name: 'SASE安全',
        description: 'SASE网关即插即用',
        category: '热门产品',
        icon: '/src/assets/products/p4.svg',
        path: '/product/sase',
        keywords: ['SASE', '网关', '安全接入', '零信任']
      },
      {
        id: 'ai-token-gateway',
        name: 'AI Token 网关',
        description: '智能、统一、安全的企业级模型服务入口',
        category: 'AI智算',
        icon: '/src/assets/products/p5.svg',
        path: '/product/ai-token-gateway',
        keywords: ['AI', 'Token', '网关', '大模型', 'MCP', '工具中心', '调度']
      },
      {
        id: 'ai-computing-platform',
        name: 'AI 推理平台',
        description: '提供从IaaS、PaaS、MaaS的完整能力',
        category: 'AI智算',
        icon: '/src/assets/products/p5.svg',
        path: '/product/ai-computing-platform',
        keywords: ['AI', '推理', '算力', 'IaaS', 'PaaS', 'MaaS', '智算']
      },
      {
        id: 'ai-native-platform',
        name: 'AI native 平台',
        description: '用于生产和治理可审计、可托管的智能体',
        category: 'AI智算',
        icon: '/src/assets/products/p6.svg',
        path: '/product/ai-native-platform',
        keywords: ['AI native', '原生', '智能体', '治理', '智算']
      },
      {
        id: 'ai-agent-application',
        name: 'AI 场景智能应用',
        description: '把智能体能力交付到具体业务场景',
        category: 'AI智算',
        icon: '/src/assets/products/p6.svg',
        path: '/product/ai-agent-application',
        keywords: ['AI', '智能体', 'Agent', '业务场景', '场景智能应用', '智算']
      },
      {
        id: 'hyper-converged-cloud',
        name: 'AI SOC',
        description: '面向智能安全运营的海量数据自动化分析与报告平台',
        category: 'AI智算',
        icon: '/src/assets/products/p7.svg',
        path: '/product/hyper-converged-cloud',
        keywords: ['AI SOC', 'SOC', '超融合', '云平台', '管理', '瑞和云']
      },
      {
        id: 'equal-protection-appliance',
        name: '等保一体机',
        description: '集等保二级、三级安全能力一体，满足快速合规要求',
        category: '云安全',
        icon: '/src/assets/products/p8.svg',
        path: '/product/equal-protection-appliance',
        keywords: ['等保', '一体机', '合规', '等级保护']
      },
      {
        id: 'multi-cloud-management',
        name: '多云管理',
        description: '统一纳管多云、多数据中心资源，实现集中管控、资源调度、成本管控与运维一体化。',
        category: '算力网络',
        icon: '/src/assets/products/p9.svg',
        path: '/product/multi-cloud-management',
        keywords: ['多云', '多云管理', '管理', 'VPN', 'SRv6', '算力网络', 'MCMP']
      },
      {
        id: 'next-gen-firewall',
        name: '下一代防火墙',
        description: '网络运行可靠稳定和业务数据安全无忧',
        category: '安全产品',
        icon: '/src/assets/products/11.svg',
        path: '/product/next-gen-firewall',
        keywords: ['防火墙', 'NGFW', '网络安全', '边界防护']
      },
      {
        id: 'web-application-firewall',
        name: 'Web应用防火墙',
        description: '提供SQL 注入、XSS 跨站等 Web 攻击防护能力，防护网页业务安全',
        category: '安全产品',
        icon: '/src/assets/products/12.svg',
        path: '/product/web-application-firewall',
        keywords: ['WAF', 'Web安全', '应用防火墙', 'Web防护']
      },
      {
        id: 'database-audit',
        name: '数据库审计综合管理系统',
        description: '全程审计数据库访问与操作行为，精准审计风险操作',
        category: '安全产品',
        icon: '/src/assets/products/13.svg',
        path: '/product/database-audit',
        keywords: ['数据库', '审计', '安全', '合规']
      },
      {
        id: 'ops-audit',
        name: '运维审计系统',
        description: '提升用户IT管理的安全和效益',
        category: '安全产品',
        icon: '/src/assets/products/14.svg',
        path: '/product/ops-audit',
        keywords: ['运维', '审计', '堡垒机', 'IT管理']
      },
      {
        id: 'log-audit',
        name: '日志审计系统',
        description: '集中采集分析全网各类日志，统一分析溯源、合规留存并预警异常行为',
        category: '安全产品',
        icon: '/src/assets/products/15.svg',
        path: '/product/log-audit',
        keywords: ['日志', '审计', '安全分析', 'SIEM']
      },
      {
        id: 'vulnerability-scanner',
        name: '脆弱性扫描系统与管理系统',
        description: '自动探测网络及系统软漏洞，精准发现安全漏洞并提供修复建议',
        category: '安全产品',
        icon: '/src/assets/products/16.svg',
        path: '/product/vulnerability-scanner',
        keywords: ['漏洞', '扫描', '脆弱性', '风险评估']
      },
      {
        id: 'host-security-management',
        name: '主机安全管理系统',
        description: '保障服务器、终端等主机资产安全的核心防线',
        category: '安全产品',
        icon: '/src/assets/products/p4.svg',
        path: '/product/host-security-management',
        keywords: ['主机安全', '勒索防护', '恶意代码防护', '入侵防御', '基线合规', '行为审计']
      },
      {
        id: 'full-traffic',
        name: '全流量',
        description: '实时抓取全网原始流量，深度解析溯源，精准发现隐蔽威胁与异常行为。',
        category: '安全产品',
        icon: '/src/assets/products/p2.svg',
        path: '/product/full-traffic',
        keywords: ['全流量', '流量分析', '溯源', '威胁发现', 'pcap']
      },
      {
        id: 'quantum-key-management',
        name: '量子密钥管理系统',
        description: '统一管控量子密钥全生命周期，实现密钥分发、存储调度与安全协同应用。',
        category: '安全产品',
        icon: '/src/assets/products/p1.svg',
        path: '/product/quantum-key-management',
        keywords: ['量子密钥', 'KMS', '密钥管理', '量子加密', '密码服务']
      },
      {
        id: 'storage/software',
        name: '芯存 XNAS 软件',
        description: '新一代智能存储操作系统',
        category: '存储',
        icon: '/src/assets/products/p1.svg',
        path: '/product/storage/software',
        keywords: ['芯存', 'XNAS', '存储软件', 'NAS', 'ZFS', '欧拉']
      },
      {
        id: 'storage/xc-3000',
        name: 'XC-3000 系列全闪 NAS',
        description: '信创机架式全闪旗舰，NVMe 与 NVMe-oF 低时延',
        category: '存储',
        icon: '/src/assets/products/p1.svg',
        path: '/product/storage/xc-3000',
        keywords: ['XC-3000', '全闪', 'NAS', '信创存储']
      },
      {
        id: 'storage/xc-2000',
        name: 'XC-2000 系列高性能 NAS',
        description: '大型企业全场景存储中枢，混合架构与 PB 级扩展',
        category: '存储',
        icon: '/src/assets/products/p1.svg',
        path: '/product/storage/xc-2000',
        keywords: ['XC-2000', '高性能', 'NAS']
      },
      {
        id: 'storage/xc-1000',
        name: 'XC-1000 系列机架式 NAS',
        description: '部门与中型业务机架存储，MRSS V3，多盘位与扩展柜',
        category: '存储',
        icon: '/src/assets/products/p1.svg',
        path: '/product/storage/xc-1000',
        keywords: ['XC-1000', '机架', 'NAS']
      },
      {
        id: 'storage/xc-08',
        name: 'XC-08 桌面信创 NAS',
        description: '桌面信创 NAS，小巧安静，适合办公共享与热备',
        category: '存储',
        icon: '/src/assets/products/p1.svg',
        path: '/product/storage/xc-08',
        keywords: ['XC-08', '桌面 NAS', '信创']
      }
    ],
  
    // 解决方案列表
    solutions: [
      {
        id: 'ai-platform',
        name: 'AI 算力平台解决方案',
        description: '以 AI 算力平台为底座，组合算网大脑、边缘推理和安全资源',
        category: '行业方案',
        path: '/solutions/ai-platform',
        keywords: ['AI', '算力平台', '智算', '算网大脑', '边缘推理']
      },
      {
        id: 'ai-native-platform-solution',
        name: 'AI native 平台解决方案',
        description: '以测试数字员工为切入点，把需求、用例、执行和回归连成可审计流程',
        category: '行业方案',
        path: '/solutions/ai-native-platform',
        keywords: ['AI native', '测试数字员工', '用例生成', '质量保障', '回归']
      },
      {
        id: 'comprehensive-xinchuang-solution',
        name: '全面拥抱信创',
        description: '国产化生态适配与信创升级替代方案',
        category: '信创专题',
        path: '/solutions/comprehensive-xinchuang',
        keywords: ['信创', '国产化', '鲲鹏', '飞腾', '龙芯', '银河麒麟', '统信UOS']
      },
      {
        id: 'sase',
        name: 'SASE安全运营解决方案',
        description: '安全访问服务边缘，零信任架构',
        category: '安全方案',
        path: '/solutions/sase',
        keywords: ['SASE', '安全运营', '零信任', '边缘安全']
      },
      {
        id: 'resource-pool',
        name: '云安全资源池解决方案',
        description: '云安全资源池统一管理方案',
        category: '安全方案',
        path: '/solutions/resource-pool',
        keywords: ['资源池', '云安全', '统一管理']
      },
      {
        id: 'equal-protection',
        name: '等保一体机解决方案',
        description: '满足等级保护合规要求的一站式解决方案',
        category: '合规方案',
        path: '/solutions/equal-protection',
        keywords: ['等保', '等级保护', '合规', '一体机']
      },
      {
        id: 'traffic-compression',
        name: '流量压缩解决方案',
        description: '智能流量处理与优化方案',
        category: '网络方案',
        path: '/solutions/traffic-compression',
        keywords: ['流量', '压缩', '过滤', '网络优化']
      },
      {
        id: 'dedicated-line-security',
        name: '运营商安全解决方案',
        description: '智能流量处理与优化方案',
        category: '网络方案',
        path: '/solutions/dedicated-line-security',
        keywords: ['专线', '安全运营', '运营', '运营平台']
      },
      {
        id: 'zwy',
        name: '政务云安全解决方案',
        description: '面向政府和公共服务机构的云安全方案',
        category: '行业方案',
        path: '/solutions/zwy',
        keywords: ['政务云', '政府', '公共服务', '云安全']
      },
      {
        id: 'password',
        name: '密码云安全资源池解决方案',
        description: '密码服务统一管理与调度',
        category: '安全方案',
        path: '/solutions/password',
        keywords: ['密码', '加密', '密钥管理', '密码资源']
      },
      {
        id: 'large-institution-internet-egress-sslo',
        name: '互联网出口安全解决方案',
        description: '基于 SSLO 安全流量编排的互联网出口流量编排与安全资源池方案',
        category: '安全方案',
        path: '/solutions/large-institution-internet-egress-sslo',
        keywords: ['互联网出口', 'SSLO', '流量编排', '安全资源池', '解密', '大型机构']
      },
      {
        id: 'ai-infrastructure-solution',
        name: 'AI基础设施解决方案',
        description: '面向大模型训练与推理的一体化 AI 基础设施方案',
        category: '基础设施方案',
        path: '/solutions/ai-infrastructure-solution',
        keywords: ['AI基础设施', '训练', '推理', '算力调度']
      },
      {
        id: 'server-virtualization-solution',
        name: '服务器虚拟化',
        description: '异构资源统一纳管与虚拟化资源池化方案',
        category: '基础设施方案',
        path: '/solutions/server-virtualization',
        keywords: ['服务器虚拟化', '资源池', '云主机', '异构纳管']
      },
      {
        id: 'edge-computing-solution',
        name: '边缘计算',
        description: '云边端一体化的边缘算力与业务协同方案',
        category: '基础设施方案',
        path: '/solutions/edge-computing',
        keywords: ['边缘计算', '云边协同', '低时延', '边缘节点']
      },
      {
        id: 'vm-container-fusion-solution',
        name: '超融合解决方案',
        description: '统一承载虚拟机与容器混合工作负载的融合方案',
        category: '基础设施方案',
        path: '/solutions/vm-container-fusion-infrastructure',
        keywords: ['容器', '虚拟机', '融合基础设施', '混合负载']
      },
      {
        id: 'database-cloud-solution',
        name: 'Paas服务解决方案',
        description: '多数据库统一管控与高可用云化基础设施方案',
        category: '基础设施方案',
        path: '/solutions/database-cloud-infrastructure',
        keywords: ['数据库云化', 'Oracle', 'MySQL', '高可用']
      },
      {
        id: 'compute-network-infra-solution',
        name: '算力网络解决方案',
        description: '全域算力与网络资源一体化编排调度方案',
        category: '基础设施方案',
        path: '/solutions/compute-network-infrastructure',
        keywords: ['算力网络', '跨域调度', '算网融合', '资源编排']
      },
      {
        id: 'ai-threat-intel-solution',
        name: 'AI加持威胁情报',
        description: 'AI 与威胁情报深度融合的主动防御方案',
        category: 'AI应用方案',
        path: '/solutions/ai-threat-intel',
        keywords: ['威胁情报', 'AI检测', 'APT', '零日漏洞', '主动防御']
      },
      {
        id: 'cloud-edge-model-collaboration-solution',
        name: '云边大小模型协同',
        description: '云端大模型与边缘小模型协同的智能运维方案',
        category: 'AI应用方案',
        path: '/solutions/cloud-edge-model-collaboration',
        keywords: ['云边协同', '大模型', '小模型', '边缘运维', '模型部署']
      },
      {
        id: 'edge-cv-security-solution',
        name: '边缘CV应用',
        description: '边缘智能视觉与安全能力融合应用方案',
        category: 'AI应用方案',
        path: '/solutions/edge-cv-security',
        keywords: ['边缘CV', '视觉安全', '边缘智能', '视频分析']
      },
      {
        id: 'vehicle-ai-offense-defense-range-solution',
        name: '车联网AI攻防靶场',
        description: '面向车联网场景的 AI 攻防训练与验证方案',
        category: 'AI应用方案',
        path: '/solutions/vehicle-ai-offense-defense-range',
        keywords: ['车联网', '攻防靶场', 'AI安全', '仿真训练']
      }
    ],
  
    // 服务列表
    services: [
      {
        id: 'security-tech',
        name: '安全技术服务',
        description: '专业的安全技术支持与咨询',
        category: '技术服务',
        path: '/services/security-tech',
        keywords: ['技术服务', '安全支持', '技术咨询']
      },
      {
        id: 'security-consulting',
        name: '安全咨询服务',
        description: '企业安全规划与战略咨询',
        category: '咨询服务',
        path: '/services/security-consulting',
        keywords: ['安全咨询', '规划', '战略']
      },
      {
        id: 'security-training',
        name: '安全培训服务',
        description: '专业安全技能培训与认证',
        category: '培训服务',
        path: '/services/security-training',
        keywords: ['培训', '认证', '技能提升']
      }
    ],
  
    // 热门搜索
    hotKeywords: [
      'AI Token 网关',
      'AI智算',
      'SASE',
      '等保一体机',
      '云安全资源池',
      '防火墙',
      'WAF',
      '运维审计',
      '日志审计'
    ],
  
    // 快速入口
    quickLinks: [
      { name: '产品中心', path: '/', icon: 'product' },
      { name: '解决方案', path: '/', icon: 'solution' },
      { name: '成功案例', path: '/#success-cases', icon: 'cases' },
      { name: '关于我们', path: '/about-us', icon: 'about' }
    ]
  };

  // 存储产品线暂不对外展示
  searchData.products = searchData.products.filter((item) => item.category !== '存储');
  
  // 搜索函数
  export function searchAll(keyword) {
    if (!keyword || keyword.trim() === '') {
      return { products: [], solutions: [], services: [] };
    }
  
    const lowerKeyword = keyword.toLowerCase().trim();
  
    const filterItems = (items) => {
      return items.filter(item => {
        const nameMatch = item.name.toLowerCase().includes(lowerKeyword);
        const descMatch = item.description.toLowerCase().includes(lowerKeyword);
        const keywordMatch = item.keywords?.some(k => k.toLowerCase().includes(lowerKeyword));
        const categoryMatch = item.category?.toLowerCase().includes(lowerKeyword);
        return nameMatch || descMatch || keywordMatch || categoryMatch;
      });
    };
  
    return {
      products: filterItems(searchData.products),
      solutions: filterItems(searchData.solutions),
      services: filterItems(searchData.services)
    };
  }
  
  // 获取热门搜索
  export function getHotKeywords() {
    return searchData.hotKeywords;
  }
  
  // 获取快速入口
  export function getQuickLinks() {
    return searchData.quickLinks;
  }
  
  
  
  
